<template>
    <vx-expandable-card class="lg:max-w-(--breakpoint-sm)">
        <template v-slot:header> Outbound Message</template>

        <template v-slot:content>
            <div v-if="loading" class="flex justify-center mt-3">
                <vx-icon-loading spin></vx-icon-loading>
            </div>

            <div v-else-if="failed" class="flex flex-col gap-6 mt-3">
                <vx-alert color="danger" :closeable="false">Failed to load data.</vx-alert>
                <vx-button size="lg" @click="loadShiftToTextMessage"> Reload </vx-button>
            </div>
            <div v-else class="flex flex-col gap-6">
                <message-builder class="my-2" v-model="message" disableSnippets disableMedia testable />
                <vx-button size="lg" :loading="loading" @click="updateShiftToTextMessage" data-test="update-button"
                    >Update</vx-button
                >
            </div>
        </template>
    </vx-expandable-card>
</template>

<script setup>
import { teamsClient } from '~/services';
import MessageBuilder from '~/components/general/message-builder/MessageBuilder.vue';
import { ref } from 'vue';
import { useToasted } from '~/composables/useToasted';
import { VxSwal, VxExpandableCard, VxIconLoading, VxAlert, VxButton } from '@voxie/frontend-components';

const toasted = useToasted();

const loading = ref(true);
const failed = ref(false);
const saving = ref(false);
const message = ref('');

const loadShiftToTextMessage = () => {
    loading.value = true;
    teamsClient
        .getShiftToTextMessage(Spark.state.currentTeam.id)
        .then((r) => {
            loading.value = false;
            failed.value = false;
            message.value = r.data?.message_content || '';
        })
        .catch(() => {
            loading.value = false;
            failed.value = true;
        });
};
const updateShiftToTextMessage = () => {
    saving.value = true;
    teamsClient
        .updateShiftToTextMessage(Spark.state.currentTeam.id, message.value)
        .then(() => {
            saving.value = false;
            VxSwal.fire({
                title: 'Success!',
                text: 'Shift to Text outbound message was updated.',
                icon: 'success',
            });
        })
        .catch((error) => {
            saving.value = false;
            console.log(error);
            toasted.global.platform_error();
        });
};

loadShiftToTextMessage();
</script>
